export default function (state) {
  return {...state, error: null, errorMessage: null}
}
